import React from 'react';
import { useSelector } from 'react-redux';

import WomenMenCancerImage from '../../assets/images/death_reasons/womenMenCancerImage';
import WomenCancerEng from '../../assets/images/death_reasons/womenCancerEng';
import WomenCancerRus from '../../assets/images/death_reasons/womenCancerRus';
import Border from '../../assets/images/border';

import './women_cancer.scss';

const WomenCancer = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='womenCancer'>
            <Border />
            {language === 'ENG' ? <WomenCancerEng /> : <WomenCancerRus />}
            <WomenMenCancerImage />
            <span className='womenCancer-text'>
                {language === 'RUS' ? 'Каждой двенадцатой женщине в мире будет диагностирован рак молочной железы. Риск сохраняется, даже если ведёшь здоровый образ жизни. Самообследование, регулярные осмотры и маммография помогают выявить болезнь на ранней стадии.' : 'One in twelve women worldwide will be diagnosed with breast cancer. The risk remains, even with a healthy lifestyle. Self-examinations, regular check-ups, and mammograms help detect the disease early.'}
            </span>
        </div>
    );
};

export default WomenCancer;